import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=19e10ce6&scoped=true&"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=19e10ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e10ce6",
  null
  
)

export default component.exports